import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceBanner.scss';
import serviceBanner from '../../assets/servicePage/1.png';

const ServiceBanner = () => {
    return (
        <section className='service-banner-section section-common section-bg'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 col-md-6">
                                <div className="service-banner-text" data-aos="fade-up" data-aos-duration="2000">
                                    <h2>Kanal Tedavisi</h2>
                                    <p>Kanal tedavisi, ağrılı veya enfekte dişleri çekmeden korumaya yardımcı olan etkili bir tedavi yöntemidir. Doğru uygulandığında rahatlama sağlar ve dişin işlevini sürdürmesine yardımcı olur.</p>
                                    <div className="theme-btn">
                                        <Link to="/iletisim">Randevu Al</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-6">
                                <div className="service-banner-img" data-aos="fade-up" data-aos-duration="2000">
                                    <img src={serviceBanner} alt="kanal tedavisi" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceBanner;